<template>
  <el-dialog title="机构信息修改"
    :visible.sync="visible"
    width="400px"
    append-to-body
    @closed='handleClose'
    :close-on-press-escape="false">
    <el-form :model="supervise"
      ref="form"
      :rules="rules"
      label-width="90px">
      <el-form-item label="机构名称：">{{supervise.regulatorName}}</el-form-item>
      <el-form-item label="联系人："
        prop="regulatorPerson">
        <el-input v-model="supervise.regulatorPerson"></el-input>
      </el-form-item>
      <el-form-item label="手机号："
        prop="regulatorPhone">
        <el-input v-model="supervise.regulatorPhone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱："
        prop="regulatorEmail">
        <el-input v-model="supervise.regulatorEmail"></el-input>
      </el-form-item>
      <el-form-item label="地址："
        prop="regulatorAddress">
        <el-input v-model="supervise.regulatorAddress"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">关 闭</el-button>
      <el-button type="primary"
        @click="handleSubmit"
        :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'supervise-modal',
  props: {
    callback: {
      type: Function
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      supervise: { regulatorId: null, regulatorName: '', regulatorPerson: '', regulatorPhone: '', regulatorEmail: '', regulatorAddress: '' },
      rules: {
        regulatorPerson: [
          { required: true, message: '请输入机构联系人', trigger: 'blur' },
          { max: 12, message: '长度最大 12 个字符', trigger: 'blur' }
        ],
        regulatorPhone: [
          { pattern: /^1[0-9][0-9]\d{8}$/, required: true, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        regulatorEmail: [
          { type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClose () {

    },
    fetchSupervise (regulatorId) {
      this.toggleModal(true)
      this.loading = true
      this.$store.dispatch(`supervise/getregulator`, {
        payload: { regulatorId },
        success: (res) => {
          this.loading = false
          const { regulatorId, regulatorName, regulatorPerson, regulatorPhone, regulatorEmail, regulatorAddress } = res.data
          this.supervise = { ...this.supervise, regulatorId, regulatorName, regulatorPerson, regulatorPhone, regulatorEmail, regulatorAddress }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const { regulatorId, regulatorName, regulatorPerson, regulatorPhone, regulatorEmail, regulatorAddress } = this.supervise
          this.$store.dispatch('supervise/updateregulator', {
            payload: { regulatorId, regulatorName, regulatorPerson, regulatorPhone, regulatorEmail, regulatorAddress },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
